<template>
    <div>
        <div v-for="(item,index) in $parentInfo.NoSettlementInvoice.dialog_settlementInvoiceDetail.carts" :key="index">
            <div style="display: flex;flex-direction: row;justify-content:space-between;align-items:center">
                <div>
                    <div>
                        {{item.name}}
                    </div>
                    <div>
                        {{item.semester_and_date}}
                    </div>
                </div>
                <div>
                    {{item.sum_price|currency('￥')}}
                </div>
            </div>
            <div class="m-separator m-separator--space m-separator--dashed"></div>
        </div>
        <div v-if="$parentInfo.NoSettlementInvoice.dialog_settlementInvoiceDetail.discounts.length>0">
            折扣：<sapn v-for="(discount,index) in $parentInfo.NoSettlementInvoice.dialog_settlementInvoiceDetail.discounts" :key="index">{{discount.discount_name}}</sapn>
        </div>
        <div v-if="$parentInfo.NoSettlementInvoice.dialog_settlementInvoiceDetail.cashDiscounts>0">
            现金优惠:{{$parentInfo.NoSettlementInvoice.dialog_settlementInvoiceDetail.cashDiscounts|currency('￥')}}
        </div>
        <div v-if="$parentInfo.NoSettlementInvoice.dialog_settlementInvoiceDetail.otherDiscounts>0">
            其他优惠{{$parentInfo.NoSettlementInvoice.dialog_settlementInvoiceDetail.otherDiscounts|currency('￥')}}
        </div>
    </div>
</template>

<script>
    export default {
        name: "dialog_settlementInvoiceDetail",
        data() {
            return {
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleGetSettlementInvoiceDetail();
        },
        computed: {
            powers() {
                return this.$store.state.config.powers;
            },
        },
        methods: {
            handleGetSettlementInvoiceDetail(){
                this.$wApi.send(this.$parentInfo.path, 'get_settlementInvoice_detail', {
                    settlement_invoice_id:this.$store.state.modal.data.settlement_invoice_id
                });
            },
        }
    }
</script>

<style scoped>

</style>